import { useEffect } from 'react';
import { PATH } from '@/app/routes';
import { useNavigate } from 'react-router-dom';
import { ClientLocationDto, ServiceTypeEnum } from '@/app/store/api/restApi';
import {
  useAppDispatch,
  useAppSelector,
  setDeliveryType,
  setDeliveryOption,
  setTakeoutDisabled,
  setDeliveryDisabled,
  setOrderPointDisabled,
} from '@/app/store';
import { DeliveryOptionEnum } from '@/entities';

export const useActualiseDeliveryTypes = ({
  locations,
  locationsLoading,
}: {
  locationsLoading: boolean;
  locations: ClientLocationDto[];
}) => {
  const nav = useNavigate();
  const dispatch = useAppDispatch();
  const deliveryType = useAppSelector((state) => state.order.deliveryType);

  useEffect(() => {
    if (!locationsLoading) {
      const takeoutAvailable = locations.find((loc) => loc.takeout?.isActive);
      const deliveryAvailable = locations.find((loc) => loc.delivery?.isActive);
      const orderPointAvailable = locations.find((loc) => loc.orderPoint?.isActive);

      dispatch(setTakeoutDisabled(!takeoutAvailable));
      dispatch(setDeliveryDisabled(!deliveryAvailable));
      dispatch(setOrderPointDisabled(!orderPointAvailable));

      // доступна только доставка курьером или выбран самовывоз, но он стал недоступен
      const condition1 =
        (!takeoutAvailable && !orderPointAvailable) || (!takeoutAvailable && deliveryType === ServiceTypeEnum.Takeout);

      // выбран способ доставки, но он стал недоступен
      const condition2 =
        (!deliveryAvailable && deliveryType === ServiceTypeEnum.Delivery) ||
        (!orderPointAvailable && deliveryType === ServiceTypeEnum.OrderPoint);

      if (!takeoutAvailable && !deliveryAvailable && !orderPointAvailable) nav(PATH.emptyDeliveryTypes);
      else {
        if (!deliveryAvailable && !orderPointAvailable) dispatch(setDeliveryType(ServiceTypeEnum.Takeout));
        else if (!deliveryAvailable && !takeoutAvailable) {
          dispatch(setDeliveryType(ServiceTypeEnum.OrderPoint));
          dispatch(setDeliveryOption(DeliveryOptionEnum.OrderPoint));
        } else if (condition1) {
          dispatch(setDeliveryType(ServiceTypeEnum.Delivery));
          dispatch(setDeliveryOption(DeliveryOptionEnum.Courier));
        } else if (condition2) {
          dispatch(setDeliveryType(ServiceTypeEnum.Takeout));
          if (!deliveryAvailable) dispatch(setDeliveryOption(DeliveryOptionEnum.OrderPoint));
          else dispatch(setDeliveryOption(DeliveryOptionEnum.Courier));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, locations, locationsLoading, nav]);
};
